module.exports = __webpack_public_path__ + "static/media/diary.765df269.png";